import { render } from "./ClavesFinalesTable.vue?vue&type=template&id=61c78d90&scoped=true"
import script from "./ClavesFinalesTable.vue?vue&type=script&lang=js"
export * from "./ClavesFinalesTable.vue?vue&type=script&lang=js"

import "./ClavesFinalesTable.vue?vue&type=style&index=0&id=61c78d90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c78d90"]])

export default __exports__